import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import {
  DEFAULT_LOT_QTY,
  DEFAULT_METRIC,
  DEFAULT_TARGET_PCT,
  computeBasisTargets,
} from './domain/computeBasisTargets'

export function useBasisTargets() {
  const store = useStore()
  const visible = ref(true)
  const lotQty = ref(DEFAULT_LOT_QTY)
  const targetPct = ref(DEFAULT_TARGET_PCT)
  const metric = ref(DEFAULT_METRIC)

  const snapshot = computed(() => {
    const edges = store.getters.directionalEdges || {}
    const longQty = Number(edges.longQty) || 0
    const shortQty = Number(edges.shortQty) || 0
    const pmpLong = Number(edges.pmpLong) || 0
    const pmpShort = Number(edges.pmpShort) || 0
    return computeBasisTargets({
      longQty,
      shortQty,
      longNotional: pmpLong * longQty,
      shortNotional: pmpShort * shortQty,
      lotQty: lotQty.value,
      targetPct: targetPct.value,
      metric: metric.value,
    })
  })

  function toggleVisible() {
    visible.value = !visible.value
  }

  function handleKeyDown(e) {
    if (e.target && ['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName)) return
    if (e.key === 'b' || e.key === 'B') toggleVisible()
  }

  onMounted(() => {
    window.addEventListener('keydown', handleKeyDown)
  })

  onUnmounted(() => {
    window.removeEventListener('keydown', handleKeyDown)
  })

  return {
    visible,
    lotQty,
    targetPct,
    metric,
    snapshot,
    toggleVisible,
  }
}
